import styled from "styled-components";

const UINotificationBase = styled.div`
  display: inline-block;
  width: 100%;
  padding: 15px;
  white-space: pre-line;
`;

export default UINotificationBase;
